exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-inline-fix[data-v-8151f2ce] {\n    width: 100%;\n}\n", ""]);

// exports
